import type { RestoreWizardConfig } from '../types'

export const REVIEW_WIZARD_CONFIG: RestoreWizardConfig = {
  kind: 'REVIEW_STATE',
  kindLabel: 'Pull Request State Restore',
  unitIds: { select: 'review-wz-1', repositories: 'review-wz-2', targets: 'review-wz-3', plan: 'review-wz-4', order: 'review-wz-5' },
  targetScopeForm: 'REPOSITORIES',
  singleRef: false,
  instances: { noun: 'pull request', probeCapability: 'pull-request-branches' },
}
